import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { buildHeaders, XmStore } from 'core/services';
import { NdelEligibility } from 'store/ndel/models/eligibility';
import { LineEligibility } from 'store/ndel/models/line';
import { StoreAction } from 'store/actions';
import { ApiChannel } from 'core/constants';
import { ModelBase } from 'store/model-base';

@Injectable()
export class NdelApi {
    public static lineNdelEligibility(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<LineEligibility> {
        return http.get(`/lines/${params.lineId}/imei/${params.imei}/ndeleligibility`, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY }),
            params: { trialFeatures: 'WT_UPGRADE' }
        }).pipe(
            map((response: ApiResponse) => LineEligibility.create<LineEligibility>(response))
        );
    }

    public static ndelEligibility(_xmStore: XmStore, http: HttpClient): Observable<NdelEligibility> {
        return http.get('/account/ndelEligible', {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((response: ApiResponse) => NdelEligibility.create<NdelEligibility>({ ndelLineEligibilities: response }))
        );
    }
}

ModelBase.fetchMapping[StoreAction.GET_LINE_NDEL_ELIGIBILITY] = NdelApi.lineNdelEligibility;
ModelBase.fetchMapping[StoreAction.GET_NDEL_ELIGIBILITY] = NdelApi.ndelEligibility;
